<!--
 * @Description: 申请开票-开票内容
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm
    ref="formRef"
    label-position="right"
    scrollToError
    :model="formData"
    :rules="formRules"
    :column-count="2"
  >
    <BaseFormItem label="个体户名称" prop="theSellerId">
      <BaseSelect
        class="form-dialog__w280"
        placeholder="请选择"
        label-key="individualName"
        value-key="individualId"
        :init="false"
        :remoteMethod="gthRemote"
        v-model="formData.theSellerId"
        @change="onGthChange"
      ></BaseSelect>
    </BaseFormItem>
    <BaseFormItem label="统一社会信用代码" prop="entpCertNo">
      <BaseInput
        class="form-dialog__w280"
        placeholder="请填写"
        v-model="formData.entpCertNo"
      />
    </BaseFormItem>
    <BaseFormItem label="发票类型" prop="invoiceType">
      <BaseSelect
        class="form-dialog__w280"
        type="text"
        placeholder="请输入"
        v-model="formData.invoiceType"
        :options="INVOICE_TYPE"
        @change="onInvoiceTypeChange"
      ></BaseSelect>
    </BaseFormItem>
    <BaseFormItem label="开票类目" prop="itemId">
      <BaseSelect
        class="form-dialog__w280"
        type="text"
        placeholder="请选择"
        label-key="itemName"
        value-key="id"
        :disabled="!formData.theSellerId || !formData.invoiceType || disabled"
        :init="false"
        :remoteMethod="itemIdRemote"
        v-model="formData.itemId"
      ></BaseSelect>
    </BaseFormItem>
    <BaseFormItem label="交易结构" prop="taxPattern">
      <BaseSelect
        class="form-dialog__w280"
        type="text"
        placeholder="请选择"
        v-model="formData.taxPattern"
        :options="[taxPatternMapping[5]]"
      ></BaseSelect>
    </BaseFormItem>
    <BaseFormItem label="选择日期" prop="receiveAt">
      <BaseDatePicker
        class="form-dialog__w280"
        style="width: 280px"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        type="daterange"
        v-model="formData.receiveAt"
      ></BaseDatePicker>
    </BaseFormItem>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { withDefaults, defineProps, ref, defineExpose, defineModel } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseDatePicker,
  BaseSelect,
  BaseInput
} from 'xrk-components';
import {
  MakeOutAnInvoiceParams,
  NotInvoicedListParams
} from '@V/invoice/src/data-source/types';
import {
  invoiceCategory,
  selectParkList
} from '@V/invoice/src/data-source/apis';
import { taxPatternMapping } from '@constants/project';
import { INVOICE_TYPE } from '@V/invoice/src/constants';
import appStore from '@/store';
import { storeToRefs } from 'pinia';

type FormData = MakeOutAnInvoiceParams & NotInvoicedListParams;

withDefaults(
  defineProps<{
    disabled?: boolean;
  }>(),
  {}
);

const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const formData = defineModel<FormData>();
const formRef = ref(null);

const formRules = {
  theSellerId: [{ required: true, message: '请选择', trigger: 'change' }],
  itemId: [{ required: true, message: '请选择', trigger: 'change' }],
  taxPattern: [{ required: true, message: '请选择', trigger: 'change' }],
  invoiceType: [{ required: true, message: '请选择', trigger: 'change' }]
};

const gthRemote = keyWord => {
  return selectParkList({
    keyWord,
    pageNum: 1,
    pageSize: 200,
    loginUserId: userInfo.value.loginUserId,
    functionCode: userInfo.value.functionCode
  });
};
const itemIdRemote = () => {
  return invoiceCategory({
    stateType: 7, // 写死7 formData.value.stateType,
    invoiceType: formData.value.invoiceType,
    theSellerId: formData.value.theSellerId
  });
};

const onGthChange = (val, [option]) => {
  formData.value.itemId = null;
  formData.value.entpCertNo = option.entpCertNo;
};
const onInvoiceTypeChange = () => {
  formData.value.itemId = null;
};
defineExpose({
  validate: (...args: any) => formRef.value?.validate(...args)
});
</script>
